import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { AgentAvatar } from '@atlaskit/rovo-agent-components';

import type { Agent } from '@atlassian/conversation-assistant-service';
import { isForgeAgent } from '@atlassian/conversation-assistant-agent';

const wrapperWithBorder = xcss({
	position: 'relative',
	filter: `drop-shadow(1px 0px 0px ${token('color.icon.inverse')}) drop-shadow(-1px 0px 0px ${token('color.icon.inverse')}) drop-shadow(0px 1px 0px ${token('color.icon.inverse')}) drop-shadow(0px -1px 0px ${token('color.icon.inverse')})`,
});

export type AgentPresenceAvatarProps = {
	agent: Agent;
	stackIndex?: number;
	showBorder?: boolean;
};

export const AgentPresenceAvatar = ({
	agent,
	stackIndex,
	showBorder,
}: AgentPresenceAvatarProps) => {
	return (
		<Box xcss={[showBorder && wrapperWithBorder]} style={{ zIndex: stackIndex }}>
			<AgentAvatar
				key={agent.id}
				agentId={agent.id}
				agentIdentityAccountId={agent.identity_account_id}
				agentNamedId={agent.external_config_reference ?? agent.named_id}
				size="medium"
				showBorder={false}
				isForgeAgent={isForgeAgent(agent)}
				forgeAgentIconUrl={agent.icon}
			/>
		</Box>
	);
};
